import React, { useRef, useState, useEffect, useCallback, useMemo } from "react";
import { FaUserCircle } from "react-icons/fa";
import { MdLogout } from "react-icons/md";
import { logoutSession } from "../../store/slices/sessionSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import TextsmsIcon from "@mui/icons-material/Textsms";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { trySuperLogin } from "../../store/slices/sessionSlice";
import {
  fetchEmployeeAuthData,
  fetchLeads,
  setEmpGroups,
} from "../../store/slices/leadsSlice";
import { fetchAllProjects } from "../../store/slices/projectsSlice";
import { setcurrentLeadID, setCurrentPageTitle } from "../../store/slices/pageSlice";
import {
  fetchGroups,
  fetchEmployeeAuthDataGroup,
} from "./../../store/slices/groupSlice";
import ChatFilters from "../features/Chat/chatfilter/chatfilters";
import AdminLoader from "../common/loader/AdminLoader";
import { resetOperationState } from "../../store/slices/OperationSlices/operationStateSlice";
import { fetchNotifications, markAllNotificationsRead, markNotificationRead } from "../../store/slices/NotificationSlices";
import socket from "../../config/socket";
import axiosInstance from "../../config/axiosConfig";
import { fetchEmployees } from "../../store/slices/employeeSlice";
import { receiveNotification } from '../../store/slices/NotificationSlices';
import { setShowWizard } from "../../store/slices/WizardSlice/WizardSlice";
import { useLoggedUser } from "../../utils/useLoggedUser";
import { applyUnreadSummary, fetchUnreadSummary } from "../../store/slices/chatSlice";

const Header = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const { session } = useSelector(state => state.session)
  const { employees } = useSelector((state) => state.employees);
  const messages = useSelector((state) => state.chat.messages);
  const chatItems = useSelector((state) => state.chat.chats || []);
  const totalChatUnread = useSelector((state) => Number(state.chat.totalUnread || 0));
  const { notifications } = useSelector(
    (state) => state.notifications
  );
  const userRole = session?.auth || localStorage.getItem("auth");

  const popupRef = useRef(null);
  const notificationSoundRef = useRef(null);
  const [showAlert, setshowAlert] = useState(false);
  const [showLogout, setshowlogout] = useState(false);
  const [showChatWindow, setshowChatWindow] = useState(false);
  const [showSupportSessions, setShowSupportSessions] = useState(false);
  const [supportSessions, setSupportSessions] = useState([]);
  const [supportSessionsLoading, setSupportSessionsLoading] = useState(false);
  const [closingSupportSessionId, setClosingSupportSessionId] = useState("");
  const [extendApprovalRequest, setExtendApprovalRequest] = useState(null);
  const [approvingExtendRequestId, setApprovingExtendRequestId] = useState("");
  const [, setShowLeveldown] = useState(false);
  const [showRolelevel, setShowRolelevel] = useState(false);
  const [role, setRole] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Pagination state
  const [displayedNotifications, setDisplayedNotifications] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);

  const notificationsPerPage = 10;
  const loggedUser = useLoggedUser()
  const participantIDs = useSelector(state => state.chat.participantIDs)
  console.log("loggedUser in header", loggedUser)
  const [matchedEmp, setMatchedEmp] = useState([])
  const [, setNotiCount] = useState(0)

  const [loggedUserLocal, SetLoggedUserLocal] = useState(null);

  useEffect(() => {
    const Email = localStorage.getItem("email")
    const Emp = employees.find((emp) => emp?.EmpEmail === Email);
    SetLoggedUserLocal(Emp)
  }, [employees])

  const Email = localStorage.getItem("email")
  const Emp = employees.find((emp) => emp?.EmpEmail === Email)

  const unreadNotifications = useMemo(
    () => notifications?.filter((notif) => notif),
    [notifications]
  );
  const unreadChatCount = useMemo(
    () => {
      if (totalChatUnread > 0) return totalChatUnread;
      return (chatItems || []).reduce((total, chat) => total + Number(chat?.unreadCount || 0), 0);
    },
    [chatItems, totalChatUnread]
  );

  console.log("gdssdgsdisplayedNotifications", displayedNotifications)
  useEffect(() => {
    dispatch(fetchEmployees());
  }, [dispatch]);

  useEffect(() => {
    if (Emp?._id) {
      dispatch(fetchNotifications({ page: 1 }));
      dispatch(fetchUnreadSummary());
    }
  }, [dispatch, Emp?._id]);

  // Filter user notifications
  const userNotifications = useMemo(() => {
    if (!Emp?._id || !unreadNotifications) return [];
    return unreadNotifications.filter((notif) => notif.userId === Emp?._id);
  }, [Emp?._id, unreadNotifications]);

  // Filter unread notifications
  const unreadnotification = useMemo(() => {
    return userNotifications.filter((notif) => !notif?.isRead);
  }, [userNotifications]);

  const extractEmailFromMessage = useCallback((message = "") => {
    const text = String(message || "").replace(/<[^>]*>/g, " ");
    const match = text.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i);
    return match?.[0] || "";
  }, []);

  const isSupportAccessNotification = useCallback((notif) => {
    const msg = String(notif?.message || "").toLowerCase();
    return msg.includes("support access") && msg.includes("approval");
  }, []);

  const isSupportExtendNotification = useCallback((notif) => {
    const notifType = String(notif?.type || "").toUpperCase();
    const msg = String(notif?.message || "").toLowerCase();
    return notifType === "SUPPORT_SESSION_EXTEND_REQUEST" || msg.includes("session extension requested");
  }, []);

  const formatRemainingTime = useCallback((sessionEnd) => {
    const end = new Date(sessionEnd).getTime();
    const diff = end - Date.now();
    if (!Number.isFinite(end) || diff <= 0) return "Expired";
    const totalMin = Math.floor(diff / 60000);
    const hrs = Math.floor(totalMin / 60);
    const mins = totalMin % 60;
    if (hrs > 0) return `${hrs}h ${mins}m`;
    return `${mins}m`;
  }, []);

  const loadSupportSessions = useCallback(async () => {
    if (userRole !== "L0") return;
    try {
      setSupportSessionsLoading(true);
      const response = await axiosInstance.get("/support/requests");
      const list = Array.isArray(response?.data) ? response.data : response?.data?.requests || [];
      const active = list.filter((item) => {
        const status = String(item?.status || "").toLowerCase();
        if (status !== "approved") return false;
        const end = item?.sessionEnd ? new Date(item.sessionEnd).getTime() : 0;
        return end > Date.now();
      });
      // Deduplicate active sessions by support user (fallback to email).
      const dedupedMap = new Map();
      active.forEach((item) => {
        const key = String(item?.supportUserId || item?.email || item?._id || item?.recordId || "");
        const prev = dedupedMap.get(key);
        const prevEnd = prev?.sessionEnd ? new Date(prev.sessionEnd).getTime() : 0;
        const currEnd = item?.sessionEnd ? new Date(item.sessionEnd).getTime() : 0;
        if (!prev || currEnd > prevEnd) {
          dedupedMap.set(key, item);
        }
      });
      const deduped = Array.from(dedupedMap.values());
      setSupportSessions(deduped);
      return deduped;
    } catch (error) {
      setSupportSessions([]);
      return [];
    } finally {
      setSupportSessionsLoading(false);
    }
  }, [userRole]);

  const approveExtendRequest = useCallback(
    async (request) => {
      const requestId = request?.requestId;
      if (!requestId) {
        enqueueSnackbar("requestId missing for extend approval.", { variant: "error" });
        return;
      }
      try {
        setApprovingExtendRequestId(String(requestId));
        await axiosInstance.post("/support/extend/approve", {
          requestId,
          duration: 20,
        });
        enqueueSnackbar("Support session extended by 20 minutes.", { variant: "success" });
        await loadSupportSessions();
        setExtendApprovalRequest(null);
      } catch (error) {
        enqueueSnackbar(error?.response?.data?.message || "Failed to approve extension request.", {
          variant: "error",
        });
      } finally {
        setApprovingExtendRequestId("");
      }
    },
    [enqueueSnackbar, loadSupportSessions]
  );

  const closeSupportSession = useCallback(
    async (session) => {
      const supportUserId = session?.supportUserId;
      if (!supportUserId) {
        enqueueSnackbar("supportUserId missing for this session.", { variant: "error" });
        return;
      }
      try {
        setClosingSupportSessionId(String(supportUserId));
        await axiosInstance.post("/support/force-logout", { supportUserId });
        enqueueSnackbar(`Closed session for ${session?.email || "support user"}.`, { variant: "success" });
        loadSupportSessions();
      } catch (error) {
        enqueueSnackbar(error?.response?.data?.message || "Failed to close support session.", {
          variant: "error",
        });
      } finally {
        setClosingSupportSessionId("");
      }
    },
    [enqueueSnackbar, loadSupportSessions]
  );

  useEffect(() => {
    if (!showSupportSessions) return;
    loadSupportSessions();
    const timer = setInterval(() => {
      loadSupportSessions();
    }, 30000);
    return () => clearInterval(timer);
  }, [loadSupportSessions, showSupportSessions]);

  // Initialize displayed notifications when notifications change
  useEffect(() => {
    if (userNotifications.length > 0) {
      const initialNotifications = userNotifications.slice(0, notificationsPerPage);
      setDisplayedNotifications(initialNotifications);
      setCurrentPage(1);
      setHasMore(userNotifications.length > notificationsPerPage);
    } else {
      setDisplayedNotifications([]);
      setCurrentPage(1);
      setHasMore(false);
    }
  }, [userNotifications]);

  // Function to load more notifications
  const loadMoreNotifications = () => {
    if (loadingMore || !hasMore) return;

    setLoadingMore(true);

    // Calculate next page
    const nextPage = currentPage + 1;
    const endIndex = nextPage * notificationsPerPage;

    // Get next batch of notifications
    const nextNotifications = userNotifications.slice(0, endIndex);

    setDisplayedNotifications(nextNotifications);
    setCurrentPage(nextPage);
    setHasMore(userNotifications.length > nextNotifications.length);

    setLoadingMore(false);
  };

  // Function to play notification sound
  const playNotificationSound = useCallback(() => {
    try {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      const audioContext = new AudioContext();

      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      oscillator.frequency.value = 800;
      oscillator.type = 'sine';
      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);

      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.5);
    } catch (error) {
      console.error("Error playing notification sound:", error);
      try {
        const audio = new Audio();
        audio.src = "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQQAAAAAAA==";
        audio.volume = 0.3;
        audio.play().catch(e => console.log("HTML5 audio fallback also failed:", e));
      } catch (fallbackError) {
        console.log("All audio methods failed");
      }
    }
  }, []);

  useEffect(() => {
    if (!Emp?._id) return;
    socket.emit("register", Emp?._id);
    if (!socket.connected) socket.connect();

    const refreshChatUnread = () => {
      dispatch(fetchUnreadSummary());
    };

    const handleUnreadSync = (payload = {}) => {
      dispatch(applyUnreadSummary(payload));
    };

    const handleNewNotification = (notif) => {
      dispatch(receiveNotification(notif));

      const notificationsArray = Array.isArray(notif) ? notif : [notif];

      const filteredNotifications = notificationsArray.filter(
        (notification) => notification.userId === Emp?._id
      );

      filteredNotifications.forEach((notification) => {
        playNotificationSound();
        enqueueSnackbar(notification.message, {
          variant: "info",
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
        });
      });

      // Reset displayed notifications when new notification arrives
      setCurrentPage(1);
    };

    socket.on("new-notification", handleNewNotification);
    socket.on("new_message", refreshChatUnread);
    socket.on("chat:unread_sync", handleUnreadSync);
    socket.on("chat:read_ack", refreshChatUnread);
    socket.emit("unread_sync");

    return () => {
      socket.off("new-notification", handleNewNotification);
      socket.off("new_message", refreshChatUnread);
      socket.off("chat:unread_sync", handleUnreadSync);
      socket.off("chat:read_ack", refreshChatUnread);
    };
  }, [Emp?._id, dispatch, enqueueSnackbar, playNotificationSound]);

  useEffect(() => {
    const matchedEmployees = employees.filter(emp => participantIDs.includes(emp._id));
    setMatchedEmp(matchedEmployees)
  }, [participantIDs, employees])

  useEffect(() => {
    const ShowNotificationUser = matchedEmp.filter(emp => emp._id === loggedUser._id);
    if (!ShowNotificationUser.length > 0) {
      setNotiCount(messages.length)
    }
  }, [matchedEmp, loggedUser, messages])

  useEffect(() => {
    if (userRole === "L0") {
      dispatch(setEmpGroups());
    }
  }, [userRole, dispatch]);

  const currentPageTitle = useSelector((state) => state.page.currentPageTitle);
  const currentLeadID = useSelector((state) => state.page.currentLeadID);

  useEffect(() => {
    dispatch(setCurrentPageTitle());
    dispatch(setcurrentLeadID());

  }, [dispatch]);

  useEffect(() => {
    const pageTitle = currentPageTitle
    dispatch(setCurrentPageTitle(pageTitle));
  }, [dispatch, location.pathname, currentPageTitle]);

  useEffect(() => {
    if (userRole) {
      dispatch(fetchEmployeeAuthData()).then(() => {
        dispatch(fetchLeads());
        dispatch(fetchGroups());
      });
    }
  }, [dispatch, userRole]);

  useEffect(() => {
    dispatch(fetchLeads());
    dispatch(fetchAllProjects());
  }, [dispatch]);

  const SuperUser = localStorage.getItem("SuperUser");

  const name = localStorage.getItem("name");
  const logout = (e) => {
    e.preventDefault();
    setshowlogout(!showLogout);
    setshowChatWindow(false);
    setshowAlert(false);
    // dispatch(resetOperationState());
    dispatch(setShowWizard(false))
  };

  const alerttoggle = (e) => {
    e.preventDefault();
    setshowAlert(!showAlert);
    setshowlogout(false);
  };

  const logoutUser = (e) => {
    e.preventDefault();
    dispatch(logoutSession());
    enqueueSnackbar("Successfully Logged out!", {
      variant: "success",
    });
    navigate("/");
  };

  const alertRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (alertRef.current && !alertRef.current.contains(event.target)) {
        setshowAlert(showAlert);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showAlert]);

  const chatRefLevel = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        chatRefLevel.current &&
        !chatRefLevel.current.contains(event.target)
      ) {
        setshowChatWindow(false);
        setshowlogout(false);
        setshowAlert(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRefLevel = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefLevel.current &&
        !dropdownRefLevel.current.contains(event.target)
      ) {
        setShowLeveldown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const loginSuccessCallback = useCallback(
    async (responseauth) => {
      if (location.pathname === "/dashboard`") {
        window.location.reload();
      } else {
        navigate(`/dashboard`);
      }

      enqueueSnackbar("User Switched in successfully!", {
        variant: "success",
      });
    },
    [navigate, enqueueSnackbar, location]
  );

  const changeAuth = async (Level) => {
    if (Level === "L0") {
      setRole("Admin");
    } else if (Level === "L1") {
      setRole("Director");
    } else if (Level === "L2") {
      setRole("Finance Dept");
    } else if (Level === "L5") {
      setRole("Accounting Dept");
    } else if (Level === "L3") {
      setRole("Sales & PreSales Dept");
    } else if (Level === "L4OM") {
      setRole("Operation manager");
    } else if (Level === "L4OP") {
      setRole("Operation Person");
    }
    setIsLoading(true);
    try {
      const resultAction = await dispatch(
        trySuperLogin({
          Level,
          loginSuccessCallback,
        })
      );
      if (trySuperLogin.fulfilled.match(resultAction)) {
        dispatch(fetchEmployeeAuthData());
        dispatch(fetchLeads());
        dispatch(fetchGroups());
        dispatch(fetchEmployeeAuthDataGroup());
      } else {
        enqueueSnackbar("Super login failed", { variant: "error" });
        setIsLoading(false);
      }
    } catch (error) {
      enqueueSnackbar(error.message || "Login failed", { variant: "error" });
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowRolelevel(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handlenotificationread = useCallback(
    async (id) => {
      try {
        await dispatch(markNotificationRead(id));
      } catch (error) {
        console.error("Failed to mark notification as read:", error);
        enqueueSnackbar("Failed to mark notification as read", {
          variant: "error",
        });
      } finally {
        enqueueSnackbar("Notification Marked As Read", {
          variant: "success",
        });
      }
    },
    [dispatch, enqueueSnackbar]
  );

  const handleNotificationClick = useCallback(
    async (notif) => {
      await handlenotificationread(notif?._id);

      // Only for Admin (L0): open support approval block
      if (userRole === "L0" && isSupportAccessNotification(notif)) {
        const email = extractEmailFromMessage(notif?.message);
        const requestId = notif?.recordId || notif?.requestId || notif?.meta?.requestId || "";
        setshowAlert(false);
        if (email && requestId) {
          navigate(
            `/dashboard/support-requests?email=${encodeURIComponent(email)}&requestId=${encodeURIComponent(
              requestId
            )}`
          );
        } else if (email) {
          navigate(`/dashboard/support-requests?email=${encodeURIComponent(email)}`);
        } else {
          navigate(`/dashboard/support-requests`);
        }
      }

      // Only for Admin (L0): open session extension approval panel
      if (userRole === "L0" && isSupportExtendNotification(notif)) {
        const email = extractEmailFromMessage(notif?.message);
        const requestId = String(notif?.recordId || notif?.requestId || notif?.meta?.requestId || "");
        const supportUserId = String(notif?.supportUserId || notif?.meta?.supportUserId || "");
        const refreshed = (await loadSupportSessions()) || [];
        const match =
          refreshed.find(
            (s) =>
              (supportUserId && String(s?.supportUserId || "") === supportUserId) ||
              (email && String(s?.email || "").toLowerCase() === String(email).toLowerCase())
          ) || null;

        setExtendApprovalRequest({
          requestId,
          email: email || match?.email || "",
          supportUserId: supportUserId || String(match?.supportUserId || ""),
          sessionEnd: match?.sessionEnd || null,
        });
        setShowSupportSessions(true);
        setshowAlert(false);
        setshowChatWindow(false);
        setshowlogout(false);
      }
    },
    [
      extractEmailFromMessage,
      handlenotificationread,
      isSupportAccessNotification,
      isSupportExtendNotification,
      loadSupportSessions,
      navigate,
      userRole,
    ]
  );

  const Readall = async () => {
    try {
      await dispatch(markAllNotificationsRead());
    } catch (error) {
      console.error("Failed to mark notification as read:", error);
      enqueueSnackbar("Failed to mark notification as read", {
        variant: "error",
      });
    } finally {
      enqueueSnackbar("All Notifications Marked As read", {
        variant: "success",
      });
      setshowAlert(!showAlert);
    }
  };


  const formatNotificationDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();

    const isToday = date.toDateString() === now.toDateString();

    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);
    const isYesterday = date.toDateString() === yesterday.toDateString();

    // Format time without seconds — e.g. "7:09 PM"
    const time = date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });

    if (isToday) return `Today, ${time}`;
    if (isYesterday) return `Yesterday, ${time}`;

    // Format normal date
    const formattedDate = date.toLocaleDateString([], {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });

    return `${formattedDate}, ${time}`;
  };

  const EmpAuthLevel = localStorage.getItem("auth");
  // const customRoles = localStorage.getItem("auth");

  const getEmpDesignation = () => {
    if (!EmpAuthLevel) return "";

    if (EmpAuthLevel === "L0") return "Admin";
    if (EmpAuthLevel === "L1") return "Director";

    if (EmpAuthLevel === "L2") return "Finance Dept";
    if (EmpAuthLevel === "L5") return "Accounting Dept";

    if (EmpAuthLevel === "L3") return "Sales Person";

    if (EmpAuthLevel === "L4") {
      if (loggedUserLocal?.customRoles?.includes("operations")) {
        return `${loggedUserLocal?.servicetype} Employee`;
      }
      if (loggedUserLocal?.customRoles?.includes("project manager")) {
        return `${loggedUserLocal?.servicetype} Manager`;
      }
      return "";
    }

    return "Unknown";
  };


  return (
    <div className="w-full">
      <audio
        ref={notificationSoundRef}
        preload="auto"
        style={{ display: 'none' }}
      >
        <source src="/notification-sound.mp3" type="audio/mpeg" />
        <source src="/notification-sound.wav" type="audio/wav" />
        <source src="/notification-sound.ogg" type="audio/ogg" />
        Your browser does not support the audio element.
      </audio>

      {isLoading ? (
        <AdminLoader isLoading={isLoading} />
      ) : (
        <div className="pt-1 flex w-full">
          <div className="bg-white p-2 w-full flex justify-between align-middle items-center rounded-md">

            <div className="flex gap-2 justify-center align-middle items-center">
              <h1 className="text-xl font-semibold">
                {currentPageTitle}
              </h1>
              <h1>
                {currentPageTitle !== "Search Existing Project" && (
                  <>
                    {currentLeadID ? `(Quotation - ${currentLeadID})` : ""}
                  </>
                )}
              </h1>
            </div>

            <div
              ref={alertRef}
              className="relative flex gap-2 align-middle items-center mr-[2%] bg-transparent bg-red-600"
            >
              <div
                ref={chatRefLevel}
                className="flex gap-2 align-middle items-center"
              >
                <div className="relative cursor-pointer">
                  {userRole === "L0" ? (
                    <div className="relative">
                      <AccessTimeIcon
                        onClick={() => {
                          setShowSupportSessions((prev) => !prev);
                          setshowChatWindow(false);
                          setshowAlert(false);
                          setshowlogout(false);
                        }}
                        className="text-black cursor-pointer w-6 h-6"
                      />
                      {supportSessions.length > 0 ? (
                        <span className="absolute -top-1 -right-1 opacity-90 bg-green-600 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full leading-none">
                          {supportSessions.length}
                        </span>
                      ) : null}
                      {showSupportSessions ? (
                        <div className="absolute top-full right-0 mt-2 w-80 max-h-80 overflow-auto bg-white border shadow-xl rounded-lg z-[1500]">
                          <div className="px-3 py-2 border-b font-semibold text-sm">Ongoing Support Sessions</div>
                          {extendApprovalRequest ? (
                            <div className="p-3 border-b bg-blue-50">
                              <p className="text-sm font-semibold">Extension Request</p>
                              <p className="text-xs break-all">{extendApprovalRequest.email || "Unknown email"}</p>
                              <p className="text-xs text-gray-600 mt-1">
                                Current time left:{" "}
                                {extendApprovalRequest.sessionEnd
                                  ? formatRemainingTime(extendApprovalRequest.sessionEnd)
                                  : "-"}
                              </p>
                              <button
                                onClick={() => approveExtendRequest(extendApprovalRequest)}
                                disabled={
                                  !extendApprovalRequest?.requestId ||
                                  approvingExtendRequestId === String(extendApprovalRequest?.requestId)
                                }
                                className="mt-2 text-xs px-2 py-1 rounded border border-blue-600 text-blue-700 hover:bg-blue-100"
                              >
                                {approvingExtendRequestId === String(extendApprovalRequest?.requestId)
                                  ? "Approving..."
                                  : "Approve +20 min"}
                              </button>
                            </div>
                          ) : null}
                          {supportSessionsLoading ? (
                            <p className="p-3 text-xs text-gray-500">Loading...</p>
                          ) : supportSessions.length ? (
                            <ul className="divide-y">
                              {supportSessions.map((session) => (
                                <li key={session._id || session.recordId || session.requestId} className="p-3 text-sm">
                                  <div className="flex items-start justify-between gap-2">
                                    <div>
                                      <p className="font-medium break-all">{session.email || "Unknown email"}</p>
                                      <p className="text-xs text-gray-500">
                                        Time left: {formatRemainingTime(session.sessionEnd)}
                                      </p>
                                    </div>
                                    <button
                                      onClick={() => closeSupportSession(session)}
                                      disabled={
                                        !session?.supportUserId ||
                                        closingSupportSessionId === String(session?.supportUserId)
                                      }
                                      className={`text-xs px-2 py-1 rounded border ${
                                        !session?.supportUserId
                                          ? "opacity-50 cursor-not-allowed border-gray-300 text-gray-500"
                                          : "border-red-500 text-red-600 hover:bg-red-50"
                                      }`}
                                    >
                                      {closingSupportSessionId === String(session?.supportUserId)
                                        ? "Closing..."
                                        : "Close Session"}
                                    </button>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          ) : (
                            <p className="p-3 text-xs text-gray-500">No active support sessions.</p>
                          )}
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </div>
                <div className="relative cursor-pointer">
                  <TextsmsIcon
                    onClick={() => {
                      setshowChatWindow((prev) => !prev);
                      setShowSupportSessions(false);
                      setshowAlert(false);
                      setshowlogout(false);
                    }}
                    className="text-black cursor-pointer w-6 h-6"
                  />
                  {unreadChatCount > 0 ? (
                    <span
                      onClick={() => {
                        setshowChatWindow((prev) => !prev);
                        setShowSupportSessions(false);
                        setshowAlert(false);
                        setshowlogout(false);
                      }}
                      className="absolute -top-1 -right-1 opacity-90 bg-red-600 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full leading-none"
                    >
                      {unreadChatCount}
                    </span>
                  ) : null}
                </div>
                {showChatWindow && (
                  <div className="fixed top-14 right-3 z-[1600] w-[min(96vw,44rem)] shadow-2xl rounded-lg">
                    <ChatFilters />
                  </div>
                )}

                <div className="relative cursor-pointer">
                  <NotificationsActiveIcon
                    onClick={(e) => {
                      setShowSupportSessions(false);
                      alerttoggle(e);
                    }}
                    className="text-black w-6 h-6"
                  />
                  <span
                    onClick={alerttoggle}
                    className="absolute -top-1 -right-1 opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full"
                  >
                    {unreadnotification?.length}
                  </span>
                </div>
                {showAlert && (
                  <div className="notificationbox absolute top-full right-0 p-1 mt-2 w-72  z-[1400] bg-white border shadow-xl rounded-lg">
                    <div className="flex justify-end align-middle items-center p-1 border-b border-gray-500 mb-1">
                      <button
                        onClick={Readall}
                        disabled={unreadnotification?.length === 0}
                        className={`text-xs font-medium ${unreadnotification?.length === 0 ? " cursor-not-allowed" : "cursor-pointer hover:bg-blue-600 hover:text-white hover:shadow-md"} text-blue-600  border border-blue-500  px-3 py-1 rounded-lg transition-all duration-200 shadow-sm `}
                      >
                        Read All
                      </button>
                    </div>
                    <div className="h-[20rem] overflow-y-auto">
                      <ul className="divide-y gap-2 divide-gray-200">
                        {displayedNotifications && displayedNotifications?.length > 0 ? (
                          displayedNotifications.map((notif) => (
                            <li
                              onClick={() => handleNotificationClick(notif)}
                              key={notif._id}
                              className={`p-2 hover:bg-gray-100 rounded cursor-pointer border break-all whitespace-normal text-wrap mb-1 ${!notif.isRead ? "bg-blue-50" : ""
                                }`}
                            >
                              <div
                                className="font-medium text-gray-900 text-sm"
                                dangerouslySetInnerHTML={{ __html: notif.message }}
                              ></div>
                              <div className="text-xs text-gray-500">
                                {formatNotificationDate(notif.createdAt)}

                                {/* {new Date(notif.createdAt).toLocaleString()} */}
                              </div>
                            </li>
                          ))
                        ) : (
                          <li className="p-2 text-center text-gray-500">No notifications</li>
                        )}
                      </ul>
                    </div>
                    {hasMore && (
                      <div className="flex justify-end align-middle items-center p-1 border-t border-gray-200">
                        <button
                          onClick={loadMoreNotifications}
                          disabled={loadingMore}
                          className={`text-xs font-medium ${loadingMore ? "opacity-50 cursor-not-allowed" : "hover:bg-blue-50 cursor-pointer"
                            } text-blue-600 border border-blue-500 p-1 rounded-lg transition-all duration-200`}
                        >
                          {loadingMore ? "Loading..." : "Load More"}
                        </button>
                      </div>
                    )}
                  </div>
                )}

                <FaUserCircle onClick={logout} className="text-black w-6 h-6 cursor-pointer" />
                {showLogout && (
                  <div
                    ref={popupRef}
                    style={{ zIndex: 1400 }}
                    className="absolute right-0 top-full mt-1 text-black text-center px-2 w-36 shadow-2xl bg-white border border-gray-400 rounded-lg"
                  >
                    <h1 className="px-1 py-1 rounded-md text-wrap break-all text-center flex justify-center items-center ">{name}</h1>
                    <p className="text-xs pb-1">({getEmpDesignation()})</p>
                    {SuperUser === "1" && (
                      <div className=" ">
                        <div
                          ref={dropdownRefLevel}
                          onClick={(() => {
                            // dispatch(resetOperationState());
                          })}
                          className="relative flex shadow-sm p-0 -pb-4 rounded-md border border-gray-300 align-middle items-center"
                        >
                          <ExpandMoreIcon
                            color="white"
                            className="absolute cursor-pointer right-0 m-auto bg-white"
                            onClick={() => {
                              setShowRolelevel(!showRolelevel);
                              // dispatch(resetOperationState())
                            }}
                          />

                          <button
                            type="button"
                            onClick={() => {
                              setShowRolelevel(!showRolelevel)
                              // dispatch(resetOperationState())
                            }}
                            className=" border border-gray-300 text-left text-nowrap overflow-hidden rounded-md shadow-md outline-none p-2 w-full"
                          >
                            {role || "Select Role"}
                          </button>

                          {showRolelevel && (
                            <div
                              className="absolute top-full p-1 left-0 w-full cursor-pointer overflow-y-auto bg-white text-sm rounded-md border border-gray-300 shadow-lg flex flex-col gap-1 z-50"
                            >
                              <div
                                className="border shadow-md rounded-md py-1"
                                onClick={() => {
                                  changeAuth("L0");
                                  setShowRolelevel(!showRolelevel);
                                  dispatch(resetOperationState());
                                }}
                              >
                                Admin
                              </div>
                              <div
                                className="border shadow-md rounded-md py-1"
                                onClick={() => {
                                  changeAuth("L1");
                                  setShowRolelevel(!showRolelevel);
                                  setshowlogout(!showLogout);
                                  dispatch(resetOperationState());
                                }}
                              >
                                Director
                              </div>
                              <div
                                className="border shadow-md rounded-md py-1"
                                onClick={() => {
                                  changeAuth("L2");
                                  setShowRolelevel(!showRolelevel);
                                  setshowlogout(!showLogout);
                                  dispatch(resetOperationState());
                                }}
                              >
                                Finance Dept
                              </div>
                              <div
                                className="border shadow-md rounded-md py-1"
                                onClick={() => {
                                  changeAuth("L5");
                                  setShowRolelevel(!showRolelevel);
                                  setshowlogout(!showLogout);
                                  dispatch(resetOperationState());
                                }}
                              >
                                Accounting Dept
                              </div>
                              <div
                                className="border shadow-md rounded-md py-1"
                                onClick={() => {
                                  changeAuth("L3");
                                  setShowRolelevel(!showRolelevel);
                                  setshowlogout(!showLogout);
                                  dispatch(resetOperationState());

                                }}
                              >
                                Sales & PreSales Dept
                              </div>
                              <div
                                className="border shadow-md rounded-md py-1"
                                onClick={() => {
                                  changeAuth("L4OM");
                                  setShowRolelevel(!showRolelevel);
                                  setshowlogout(!showLogout);
                                  dispatch(resetOperationState());

                                }}
                              >
                                Operations Manager
                              </div>
                              <div
                                className="border shadow-md rounded-md py-1"
                                onClick={() => {
                                  changeAuth("L4OP");
                                  setShowRolelevel(!showRolelevel);
                                  setshowlogout(!showLogout);
                                  dispatch(resetOperationState());

                                }}
                              >
                                Operations Person
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    <button
                      onClick={(e) => logoutUser(e)}
                      className="flex items-center gap-2 px-6 py-2 rounded-md my-1 cursor-pointer hover:bg-black hover:text-white"
                    >
                      <MdLogout size={24} /> Logout
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;